import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import Logo from '@/components/Logo'
import AuthBackgroundShape from '@/components/AuthBackgroundShape'
import RegisterForm from '@/components/shadcn-studio/blocks/register-01/register-form'

const Register = () => {
  return (
    <div className='relative flex h-auto min-h-screen items-center justify-center overflow-x-hidden px-4 py-10 sm:px-6 lg:px-8'>
      <div className='absolute'>
        <AuthBackgroundShape />
      </div>

      <Card className='z-1 w-full border-none shadow-md sm:max-w-lg'>
        <CardHeader className='gap-3 items-center justify-center'>
          <Logo className='gap-3 mx-auto' showText={false} />

          <div className='text-center'>
            <CardTitle className='mb-1.5 text-2xl text-center'>Sign Up to Fenra</CardTitle>
          </div>
        </CardHeader>

        <CardContent>
          {/* Register Form */}
          <div className='space-y-4'>
            <RegisterForm />

            <p className='text-muted-foreground text-center'>
              Already have an account?{' '}
              <Link to='/auth/login' className='text-card-foreground hover:underline'>
                Sign in instead
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default Register
